export default __webpack_public_path__ + "static/media/TwitchGlitchPurple.2154fb6d.svg";